import { Link, useLocation } from "react-router-dom";
import { Scale } from "lucide-react";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { LEGAL_PAGES, LEGAL_UPDATED } from "@/lib/legal";
import { AdBanner } from "@/components/AdBanner";

export const LegalLayout = ({ title, subtitle, sections, testId }) => {
  const { pathname } = useLocation();
  return (
    <div className="bg-white min-h-screen" data-testid={testId}>
      <Navbar />
      <main className="pt-24 sm:pt-28 pb-16 sm:pb-24 max-w-6xl mx-auto px-4 sm:px-6">
        <header className="mb-8 sm:mb-12 max-w-3xl">
          <span className="inline-flex items-center gap-2 text-cyan-600 font-medium text-sm">
            <Scale className="h-4 w-4" /> Información legal
          </span>
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-heading font-bold text-slate-900 tracking-tight mt-3" data-testid="legal-title">
            {title}
          </h1>
          <p className="mt-4 text-slate-600">{subtitle}</p>
          <p className="mt-2 text-xs text-slate-400">Última actualización: {LEGAL_UPDATED}</p>
        </header>
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <aside className="hidden lg:block lg:col-span-3">
            <div className="sticky top-32 space-y-8">
              <nav aria-label="Índice" className="space-y-0.5" data-testid="legal-toc">
                <p className="text-xs font-semibold uppercase tracking-wider text-slate-400 mb-2">En esta página</p>
                {sections.map((s) => (
                  <a key={s.id} href={`#${s.id}`} data-testid={`legal-toc-${s.id}`}
                    className="block text-sm text-slate-500 hover:text-cyan-700 py-1.5 pl-3 border-l-2 border-slate-100 hover:border-cyan-400 transition-colors duration-150">
                    {s.title}
                  </a>
                ))}
              </nav>
              <nav aria-label="Otros documentos" className="space-y-0.5">
                <p className="text-xs font-semibold uppercase tracking-wider text-slate-400 mb-2">Documentos legales</p>
                {LEGAL_PAGES.map((p) => (
                  <Link key={p.to} to={p.to} data-testid={`legal-nav-${p.to.slice(1)}`}
                    className={`block text-sm py-1.5 pl-3 border-l-2 transition-colors duration-150 ${pathname === p.to
                      ? "text-cyan-700 border-cyan-500 font-medium" : "text-slate-500 border-slate-100 hover:text-cyan-700 hover:border-cyan-400"}`}>
                    {p.label}
                  </Link>
                ))}
              </nav>
            </div>
          </aside>
          <article className="lg:col-span-9 max-w-3xl space-y-10 legal-content">
            {sections.map((s, i) => (
              <section key={s.id} id={s.id} className="scroll-mt-32" data-testid={`legal-section-${s.id}`}>
                <h2 className="text-base md:text-lg font-heading font-semibold text-slate-900 mb-3">
                  {i + 1}. {s.title}
                </h2>
                <div className="text-sm sm:text-base text-slate-600 leading-relaxed space-y-3">{s.content}</div>
              </section>
            ))}
          </article>
        </div>
      </main>
      <AdBanner className="pb-10" />
      <Footer />
    </div>
  );
};
